import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _QuestionSettingsContainer;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@instructure/emotion';
import QuestionSettingsPanel from '../QuestionSettingsPanel';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
var QuestionSettingsContainer = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_QuestionSettingsContainer = /*#__PURE__*/function (_Component) {
  function QuestionSettingsContainer() {
    _classCallCheck(this, QuestionSettingsContainer);
    return _callSuper(this, QuestionSettingsContainer, arguments);
  }
  _inherits(QuestionSettingsContainer, _Component);
  return _createClass(QuestionSettingsContainer, [{
    key: "renderOption",
    value:
    // TODO: Kill this logic, specify panels as children where needed, then maybe replace this component with a View?
    function renderOption(_ref) {
      var key = _ref.key,
        title = _ref.title,
        component = _ref.component,
        defaultExpanded = _ref.defaultExpanded;
      return jsx(QuestionSettingsPanel, {
        key: key,
        label: title,
        defaultExpanded: defaultExpanded
      }, component);
    }
  }, {
    key: "render",
    value: function render() {
      var options = _toConsumableArray(this.props.additionalOptions.map(this.renderOption)).filter(Boolean);
      if (options.length || this.props.children) {
        return jsx("div", {
          "data-testid": "question-settings-container",
          css: this.props.styles.panelPadding
        }, this.props.children, options);
      }
      return null;
    }
  }]);
}(Component), _defineProperty(_QuestionSettingsContainer, "displayName", 'QuestionSettingsContainer'), _defineProperty(_QuestionSettingsContainer, "componentId", "Quizzes".concat(_QuestionSettingsContainer.displayName)), _defineProperty(_QuestionSettingsContainer, "propTypes", {
  children: PropTypes.node,
  additionalOptions: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    component: PropTypes.node.isRequired,
    defaultExpanded: PropTypes.bool
  })),
  styles: PropTypes.object
}), _defineProperty(_QuestionSettingsContainer, "defaultProps", {
  children: null,
  additionalOptions: []
}), _QuestionSettingsContainer)) || _class);
export { QuestionSettingsContainer as default };